<template>
	<div class="width-100 display-flex flex-row flex-align-center tabs-container px-5 py-2">
		<InstallationWizardTabs v-if="installationMode" v-bind="$attrs" v-on="$listeners" />
		<EditConfigurationTabs v-else v-bind="$attrs" v-on="$listeners" />
	</div>
</template>
<script>
import EditConfigurationTabs from '@/views/Flow/configurations/SetupMenu/EditConfigurationTabs.vue';
import InstallationWizardTabs from '@/views/Flow/configurations/SetupMenu/InstallationWizardTabs.vue';
export default {
	name: 'SetupTabs',
	props: { installationMode: { type: Boolean } },
	components: { EditConfigurationTabs, InstallationWizardTabs },
};
</script>
<style scoped lang="scss">
.tabs-container {
	background: var(--setup-node-container-background);
}
</style>
